import { apiClient } from "./apiClient";

export interface AutoTradingStatus {
  is_enabled: boolean;
  state: "stopped" | "running" | "pending_switch" | "error";
  account_uuid: string | null;
  started_at: string | null;
}

export interface UpdateAccountUuidRequest {
  account_uuid: string;
}

export const autoTradingApi = {
  getStatus: async (): Promise<AutoTradingStatus> => {
    const response = await apiClient.get<AutoTradingStatus>("/v1/auto-trading/status");
    return response.data;
  },

  start: async (): Promise<AutoTradingStatus> => {
    const response = await apiClient.post<AutoTradingStatus>("/v1/auto-trading/start");
    return response.data;
  },

  stop: async (): Promise<AutoTradingStatus> => {
    const response = await apiClient.post<AutoTradingStatus>("/v1/auto-trading/stop");
    return response.data;
  },

  updateAccountUuid: async (accountUuid: string): Promise<AutoTradingStatus> => {
    const response = await apiClient.patch<AutoTradingStatus>("/v1/auto-trading/account", {
      account_uuid: accountUuid,
    });
    return response.data;
  },
};
